import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { initPostHogLogs } from './config/posthogLogs';
import { setupErrorLogging } from './utils/errorLogger';
import ErrorBoundary from './components/ErrorBoundary';

initPostHogLogs();
setupErrorLogging();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);
